import React, { useState, } from 'react'
import Loader from '../components/Loader';
import { userListByDB } from '../api/user';
import { copyRecordByID } from '../api/common';
import PopupModal from '../components/PopupModal';



export default function CopyRecord() {

    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })

    const [loading, setLoading] = useState(false);

    let formInput = {
        sourceSystem: "",
        targetSystem: "",
        email: "",
        recordID: ""
    };
    let [formData, setFormData] = useState(formInput);


    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");

    const getAllUserList = async (db) => {
        setLoading(true);
        const userListData = await userListByDB(db)
        setLoading(false);
        if (userListData.status > 199 && userListData.status < 400) {
            let data = userListData.data.data
            setUserList([{ id: "", name: "Please select user" },
            ...data.map(obj => ({
                id: obj.email,
                name: obj.email
            })).sort((a, b) =>
                a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
            )
            ]);
        }
    }


    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "targetSystem") {
            getAllUserList(value);
            setFormData({ ...formData, 'targetSystem': "", email: "" })
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        // Clear error for the field being typed
        if (errors[name]) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: '',
            }));
        }

    };

    const validate = () => {
        const newErrors = {};
        if (!formData.sourceSystem) newErrors.sourceSystem = 'Select source system';
        if (!formData.targetSystem) newErrors.targetSystem = 'Select target  system';
        if (!formData.email) newErrors.email = 'Select user';
        if (!formData.recordID) newErrors.recordID = 'Select Record ID';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleCopyData = async (e) => {
        e.preventDefault();

        if (!validate()) {
            setApiError("Please add required fields")
            setErrorStatus('danger')
            return;
        }

        try {
            setLoading(true);
            let response = await copyRecordByID(formData);
            console.log("Status", response.status);
            if (response.status > 199 && response.status < 400) {
                setPopUpMessage({
                    "title": "Success",
                    "text": response.data?.message
                });
                setShowPopup(true);
            } else {
                setPopUpMessage({
                    "title": "Error",
                    "text": response?.response?.data?.message || "Internal server error."
                });
                setShowPopup(true);
            }

        } catch (error) {
            const message = error?.data?.message || error?.statusText || 'Login failed';
            setApiError(message);
            setTimeout(() => {
                setApiError(null);
                setErrorStatus('danger')

            }, 5000);
        } finally {
            setLoading(false);
        }
    };


    let [userList, setUserList] = useState([
        {
            "id": "",
            "name": "Please select user"
        }
    ]);
    let [system, setSystem] = useState([
        {
            "id": "",
            "name": "Please select system"
        },
        {
            "id": "dev",
            "name": "DEV"
        },
        {
            "id": "tdr",
            "name": "TDR"
        },
        {
            "id": "pro",
            "name": "Production"
        }
    ])

    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
            />

            <form onSubmit={handleCopyData}>
                <div className="content-wrapper">
                    <div className="page-header">
                        <h3 className="page-title"> Record Copy </h3>
                        {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}

                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <button type="submit" className="btn btn-primary me-2">Copy Data</button>
                            </ol>
                        </nav>
                    </div>
                    <div className="row">
                        <div className="col-md-4 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <div className="form-group">
                                        <label >Source System</label>
                                        <select className="form-select" name="sourceSystem" value={formData.sourceSystem} onChange={handleChange} >
                                            {system.map((obj) => (
                                                <option key={obj.id} value={obj.id}>{obj.name}</option>
                                            ))}
                                        </select>
                                        {errors.sourceSystem && <span className="text-danger">{errors.sourceSystem}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label >Target System</label>
                                        <select className="form-select" name="targetSystem" value={formData.targetSystem} onChange={handleChange} >
                                            {system.map((obj) => (
                                                <option key={obj.id} value={obj.id}>{obj.name}</option>
                                            ))}

                                        </select>
                                        {errors.targetSystem && <span className="text-danger">{errors.targetSystem}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label >Please select user</label>
                                        <select className="form-select" name="email" value={formData.email} onChange={handleChange} >
                                            {userList.map((obj) => (
                                                <option key={obj.id} value={obj.id}>{obj.name}</option>
                                            ))}
                                        </select>
                                        {errors.email && <span className="text-danger">{errors.email}</span>}
                                    </div>

                                    <div className="form-group">
                                        <label >Enter Record ID</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="recordID"
                                            value={formData.recordID}
                                            onChange={handleChange}
                                            placeholder="Record ID" />
                                        {errors.recordID && <span className="text-danger">{errors.recordID}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}
